import React, {Fragment, useEffect, useRef} from "react";
import {withFormsy} from "formsy-react";
import {Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";

import "../../style/bootstrap-components/alt-text-field.scss";

const AltTextField = withFormsy((props) => {
  const inputRef = useRef();
  const {required, hasError, value, errorText, isPristine, outlined, hideRequiredMark, label, prefix, errorMessage} = props;
  let errText = errorText || errorMessage;
  let hasErr = false;
  if (value) {
    hasErr = (hasError || (errText || errorMessage) ? true : false);
  }

  // console.log("hasErr", hasErr, props);
  useEffect(() => {
    if (props.setValue) {
      props.setValue(props.defaultValue);
    }
  }, [props.defaultValue]);

  const field = (
    <Fragment>
      <input
        ref={inputRef}
        name={props.name}
        type={props.type}
        required={props.required}
        autoComplete="off"
        spellCheck="false"
        placeholder={props.placeholder || ""}
        className={`${props.inputClass} ${(hasErr) && "has-error"}`}
        onChange={(e) => {
          props.setValue(e.target.value);
          props.onChange?.(e);
        }}
        value={props.value || ""}
        disabled={props.disabled}
      />
    </Fragment>
  );

  const ErrorMessage = () => {
    if (!errText && !errorMessage) {
      return null;
    }

    return <div className="alt-custom-text-field-error">{errText ? errText : "Oops! There's an error"}</div>;
  };

  if (props.inline) {
    return (
      <Row className="align-items-center inline alt-custom-text-field">
        {/* <label className="col-3">{label}{required && !hideRequiredMark && " *"}</label> */}
        <Col>
          {field}
          {props.afterField}
          {hasErr && <ErrorMessage errText={errText}/>}
        </Col>
      </Row>
    );
  }

  if (props.outlined) {
    return (
      <div className="alt-custom-text-field outlined">
        {prefix && <div className="outlined-suffix">{prefix}</div>}
        {field}
        <label className={`${props.value && "has-value"}`}>{label}{required && !hideRequiredMark && " *"}</label>
        {hasErr && <ErrorMessage errText={errText}/>}
      </div>
    );
  }

  return (
    <div className={`alt-custom-text-field ${prefix && "has-prefix"}`}>
      {prefix && <div className="basic-prefix">{prefix}</div>}
      {/* <label className="text-field-base-label">{label}{required && !hideRequiredMark && " *"}</label> */}
      {field}
      {hasErr && <ErrorMessage errText={errText}/>}
    </div>
  );
});

AltTextField.propTypes = {
  hasErr: PropTypes.bool, // states whether the input has error;
  errText: PropTypes.string, // can be used to add error text below the input
  required: PropTypes.bool, // can be used to have isRequired mark (*) beside the label
  hideRequiredMark: PropTypes.bool, // states whether to show required mark or not
  outlined: PropTypes.bool, // outlined variant of the text-field
  inline: PropTypes.bool, // inline variant of the text-field
  prefix: PropTypes.node, // a component attached on end of the input i.e an icon
};

export default AltTextField;
